import { render, staticRenderFns } from "./company-benefits.vue?vue&type=template&id=27e83a62"
import script from "./company-benefits.vue?vue&type=script&lang=js"
export * from "./company-benefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports